export default __webpack_public_path__ + "static/metaImage-e03e540e6de0f553a3bfe8e3fcba3f0b.png";